import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy /app bookmark -> /timer */
export const Route = createFileRoute("/app")({
	beforeLoad: () => {
		throw redirect({ to: "/timer" });
	},
});
